import React from "react";
import { Section } from "../pages/Collection";
import collectionBaner from "../assets/images/collection/collection-baner.jpg";
import { Container, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
const About = () => {
  return (
    <div>
      <Helmet title="about" />
      <Section img={collectionBaner}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat,sans-serif",
            fontWeight: 600,
            color: "white",
            zIndex: 10,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          About
        </Typography>
      </Section>

      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "row" },
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "start",
        }}
      ></Container>
    </div>
  );
};

export default About;
